
import { ArrowDownTrayIcon } from "@heroicons/vue/24/solid";
import { format } from "date-fns";
import { defineComponent } from "vue";
import { segmentAnalytics } from "@/assets/scripts";
import ImagesComparison from "@/components/UI/ImagesComparison.vue";
import CameraRepository from "@/repositories/CameraRepository";
import logger from "@/services/logger";
import { downloadZip, createZipFromUrls } from "@/services/zip";
import CameraItemLayout from "@/views/camera/partials/CameraItemLayout.vue";
import NavigationComponent from "@/views/partials/NavigationComponent";

export default defineComponent({
  name: "Compare",
  components: {
    ImagesComparison,
    NavigationComponent,
    CameraItemLayout,
    ArrowDownTrayIcon,
  },
  data() {
    return {
      cameraId: this.$route.params.camera_id as string,
      beforeDate: "",
      afterDate: "",
      loading: false,
      noData: false,
    };
  },
  mounted() {
    segmentAnalytics("camera_compare");
  },
  methods: {
    format,
    async downloadImages() {
      const { customer_name, site_id, camera_id } = this.$route.params;
      const imageList = await CameraRepository.getCameraGalleryForTimeRange(
        customer_name as string,
        site_id as string,
        camera_id as string,
        this.beforeDate,
        this.afterDate,
      );
      this.loading = true;
      createZipFromUrls(imageList)
        .then((zip) => {
          downloadZip(
            zip,
            this.currentProjectV2?.name || "Projekt",
            this.beforeDate,
            this.afterDate,
          );
        })
        .catch((error) => {
          logger.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
});
